export default __webpack_public_path__ + "static/data-vis-line-chart-do-6be4446b66e3ff0764700c7a1538723b2a23be26f148ca9c778517cee5fd0cbc.png";